import { v4 as uuidv4 } from 'uuid';

import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import { selectCohortDefinitionIsVersionLoading } from '@verantos-dev/app-state-cohort-definition';
import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';
import { CohortBuilderModalLegacy, CohortStatusLegacy } from '@verantos-dev/types-cohorts';

import { useCohortBuilderItemWithInUseItems } from './useCohortBuilderItemWithInUseItems';
import { useCohortEditable } from './useCohortEditable';
import { setModal, deleteSimpleEvent } from '../cohortBuilderSlice';
import { selectModal } from '../selectors/cohortBuilderWorkflowSelectors';
import { selectCohortDefinition, selectSimpleEvents } from '../selectors/cohortDefinitionSelectors';
import { getFullCohortDslForDeleteSimpleEvent } from '../utils/dsl-generators/getFullCohortDslForSimpleEvent';

export const useSimpleEventView = () => {
  const dispatch = useAppDispatch();
  const { data: cohortData } = useCohortBuilderData();
  const isProcessing =
    !!cohortData?.data.latestStatus &&
    [CohortStatusLegacy.PROCESSING, CohortStatusLegacy.FINAL].includes(
      cohortData?.data.latestStatus
    );
  const { isEditable } = useCohortEditable();
  const viewMode = !isEditable || isProcessing;
  // select the index date and modal from the store
  const modal = useAppSelector(selectModal);
  const currentCohortDefinition = useAppSelector(selectCohortDefinition);
  /** Cohort Builder Definition State */
  const simpleEvents = useAppSelector(selectSimpleEvents);
  const isLoading = useAppSelector(selectCohortDefinitionIsVersionLoading);
  const simpleEventsWithInUseItems = useCohortBuilderItemWithInUseItems(simpleEvents);

  /** Click Handlers */

  // open the modal to add a simple event
  const onAddSimpleEventClick = () => {
    !viewMode &&
      dispatch(
        setModal({
          id: uuidv4(),
          modal: CohortBuilderModalLegacy.ADD_SIMPLE_EVENT,
        })
      );
  };

  const onEditSimpleEventClick = (id: string) => {
    dispatch(
      setModal({
        id,
        modal: CohortBuilderModalLegacy.EDIT_SIMPLE_EVENT,
      })
    );
  };

  const onDeleteSimpleEventClick =
    (emitResearchAssistantUpdate: (nextCohortDsl: string) => void) => (id: string) => {
      if (!viewMode) {
        dispatch(deleteSimpleEvent(id));
        const nextCohortDsl = getFullCohortDslForDeleteSimpleEvent(currentCohortDefinition, id);
        emitResearchAssistantUpdate(nextCohortDsl.fullDslQueryString);
      }
    };

  return {
    simpleEvents: simpleEventsWithInUseItems,
    showSimpleEventEditModal:
      modal !== undefined &&
      [
        CohortBuilderModalLegacy.ADD_SIMPLE_EVENT,
        CohortBuilderModalLegacy.EDIT_SIMPLE_EVENT,
      ].includes(modal),
    onAddSimpleEventClick,
    onEditSimpleEventClick,
    onDeleteSimpleEventClick,
    isEditable,
    isLoading,
    viewMode,
  };
};
